import { jsx as _jsx } from "react/jsx-runtime";
import { I18nextProvider } from 'react-i18next';
import i18n from './config.js';
import CloudscapeI18nProvider from '@cloudscape-design/components/i18n';
import PolarisI18nProvider from '@amzn/awsui-components-react/polaris/i18n';
/**
 * Translation provider that wraps components with i18next context
 * This provider uses pre-loaded Cloudscape messages from the bootstrap phase
 * to avoid async operations in React components.
 */
export function TranslationProvider({ children, cloudscapeMessages, polarisMessages }) {
    const locale = document.documentElement.lang || "en";
    return (_jsx(I18nextProvider, { i18n: i18n, children: _jsx(CloudscapeI18nProvider, { locale: locale, messages: cloudscapeMessages, children: _jsx(PolarisI18nProvider, { locale: locale, messages: polarisMessages, children: children }) }) }));
}
